module.exports = __webpack_public_path__ + "img/busca-avancada-esp-marinhas-2.79811465.jpg";